export default __webpack_public_path__ + "static/media/illustration-passions.38895661.svg";